import {
  faAt,
  faEye,
  faPen,
  faLink,
  faHeart,
  faPhone,
  faIdCard,
  faMapPin,
  faRandom,
  faDesktop,
  faUserTie,
  faBuilding,
  faChartBar,
  faIndustry,
  faLanguage,
  faPenFancy,
  faChartLine,
  faMobileAlt,
  faDollarSign,
  faInfoCircle,
  faCalendarAlt,
  faChevronDown,
  faFingerprint,
  faBirthdayCake,
  faGlobeAmericas,
  faFileInvoiceDollar,
} from '@fortawesome/pro-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import {
  faTwitter,
  faFacebook,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

import { createFontAwesomeIcon } from './util';

export const Mobile = createFontAwesomeIcon(faMobileAlt);

export const Desktop = createFontAwesomeIcon(faDesktop);

export const Default = createFontAwesomeIcon(faInfoCircle);

export const Number = createFontAwesomeIcon(faChartBar);

export const Date = createFontAwesomeIcon(faCalendarAlt);

export const Boolean = createFontAwesomeIcon(faCheckCircle);

export const Url = createFontAwesomeIcon(faLink);

export const Name = createFontAwesomeIcon(faIdCard);

export const Email = createFontAwesomeIcon(faAt);

export const Phone = createFontAwesomeIcon(faPhone);

export const CompanyName = createFontAwesomeIcon(faBuilding);

export const CompanyType = createFontAwesomeIcon(faIndustry);

export const JobTitle = createFontAwesomeIcon(faPenFancy);

export const CompanySize = createFontAwesomeIcon(faUserTie);

export const Identifier = createFontAwesomeIcon(faFingerprint);

export const Timezone = createFontAwesomeIcon(faGlobeAmericas);

export const Location = createFontAwesomeIcon(faMapPin);

export const Currency = createFontAwesomeIcon(faDollarSign);

export const Gender = createFontAwesomeIcon(faHeart);

export const Birthday = createFontAwesomeIcon(faBirthdayCake);

export const Metric = createFontAwesomeIcon(faChartLine);

export const Language = createFontAwesomeIcon(faLanguage);

export const Plan = createFontAwesomeIcon(faFileInvoiceDollar);

export const Bio = createFontAwesomeIcon(faPen);

export const Social = createFontAwesomeIcon(faEye);

export const Twitter = createFontAwesomeIcon(faTwitter);

export const Facebook = createFontAwesomeIcon(faFacebook);

export const LinkedIn = createFontAwesomeIcon(faLinkedin);

// extras

export const Shuffle = createFontAwesomeIcon(faRandom);

export const ChevronDown = createFontAwesomeIcon(faChevronDown);
